export default __webpack_public_path__ + "assets/webgl/picking-16.4e9953dc.glb";